import dayjs from "dayjs";

export const roundPerformedOn = (day) => {
  const timestamp = day.unix();

  const rounded = Math.floor(timestamp / (15 * 60)) * 15 * 60;

  return dayjs.unix(rounded);
};
